import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver';

import { SessionService } from '../services/session.service';
import { UserService } from '../services/user.service';

import { Respuesta } from './../entities/respuesta.entity';
import { Factura } from './../entities/factura.entity';
import { Contrato } from './../entities/contrato.entity';
import { FacturaSeleccion } from '../entities/facturaSeleccion.entity';
import { UsuarioUpdate } from '../entities/usuarioUpdate.entity';
import { UsuarioOnline } from '../entities/UsuarioOnline.entity';
import { FacturasFiltro } from '../entities/facturasFiltro';
import { DataTableColumn, IDataTableColumnType } from '../shared/sacyr-data-table/sacyr-data-table.entity';
import { ColumnMode } from '@swimlane/ngx-datatable';

// TODO: Table. Revisar paginación en modo movil

@Component({
  selector: 'app-consumofactura',
  templateUrl: './consumofactura.component.html'
})
export class ConsumofacturaComponent implements OnInit {
  public isAuthenicated: Boolean;
  public total: number;
  public consumo: number;
  public periodo: string;
  public periodocorto: string;
  public fechalectura: string;
  public fechaFactura: string;

  public contratoSelected: Contrato;
  public contrato_num: number;
  public contratos: Contrato[];
  public facturas: Array<Factura>;
  public efactura: boolean;

  public resultado: Respuesta;
  public messageCabecera: string;
  public messageComplet: string;
  public typeException: number;
  public Facturaseleccionada: FacturaSeleccion = new FacturaSeleccion();
  public posicion: number;
  public existenFacturas: Boolean;
  public existenFacturasGrafica: Boolean;
  public rowsOnPage = 6;
  public SortBy = 'PeriodoCodigo';
  public SortOrder = 'desc';
  public direccionSuministro: string;

  private dateFac: Date;
  private hoy: Date;
  public cobrada: boolean;
  public TPVpage: string;
  public Explotacion: string;
  public isEmmasa: Boolean;
  public permitirPagoOVE: Boolean;
  public FacturaPasarela: Factura = new Factura();

  @ViewChild('myTable') table: any;

  private _colID = 'id';
  private displayedColumns = [
    'PeriodoCodigo', 'Fecha', 'FechaLecturaFactura', 'ConsumoFactura', 'TotalFacturado', 'Factura', 'Cobrada'
  ];

  data: Factura[] = [];
  rows: any[] = [];
  isMobile = false;
  _tableFullscreen = false;
  _columnMode = ColumnMode.flex;
  _minWidth = 100;

  constructor(private userService: UserService, private sessionService: SessionService, private router: Router) { }

  ngOnInit() {
    this.isEmmasa = this.sessionService.isEmmasa;
    this.Explotacion = this.sessionService.explotacion;
    this.TPVpage = this.sessionService.TPVPage;
    this.isAuthenicated = this.sessionService.isAuthenicated;

    if (this.sessionService.isAuthenicated === true) {
      this.contratos = this.sessionService.contratos;
      this.efactura = this.sessionService.efactura;

      if (this.sessionService.contratoSelected === undefined) {
        this.contratoSelected = this.sessionService.contratoSelected = this.contratos[0];
        this.sessionService.PosicionContratoSelected = 0;
      }

      this.cargarVariables(this.sessionService.contratoSelected);

      this.obtenerFacturas();
      this.onResize();
    } else {
      this.router.navigate(['/']);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event = null) {
    const windowWidth = event !== null ? event.target.innerWidth : window.innerWidth;
    this.isMobile = windowWidth < 800;
  }

  getRowItem(row: any) {
    const id = row[this._colID];
    const currentItem = this.data.find(d => d.Identificador === id);
    return currentItem;
  }

  getEstadoTexto(row: any) {
    const item = this.getRowItem(row);
    const estado = this.getEstado(item);
    return estado;
  }

  onPage(event) {
    // In case we need to do something on page changed over ngx-datatable
  }

  private getEstado(item: Factura): string {
    if ((item.Cobrada && item.Fecha !== null) || (item.Estado === 4 || item.Estado === 5)) {
      return 'Pagado';
    } else if (this.facturaPendiente(item, false)) {
      return 'Pendiente';
    } else if (item.Fecha === null) {
      return 'Albarán';
    }
    return '';
  }

  private facturaPendiente(item: Factura, isPasarela = false) {
    let result = !item.Cobrada && item.Estado !== 4 && item.Estado !== 5 && item.Fecha !== null;
    if (isPasarela) {
      return result && this.isEmmasa && this.permitirPagoOVE && (item.Estado !== 6 && item.Estado !== 10);
    }
    return result;
  }

  public recibirContrato(event): void {
    let contratoSelect: Contrato = event.contratoSeleccionado;
    this.cargarVariables(contratoSelect);
    this.obtenerFacturas();
  }

  private obtenerFacturas() {
    const datosObtenerFactura = new FacturasFiltro();
    datosObtenerFactura.ContratoCodigo = this.sessionService.contratoSelected.Codigo;
    datosObtenerFactura.Login = this.sessionService.login;

    this.userService.ObtenerFacturas(this.sessionService.explotacion, datosObtenerFactura)
      .then(
        response => this.ObtenerFacturasOnSuccess(response),
        response => this.ObtenerFacturasOnError(response)
      );
  }

  private ObtenerFacturasOnSuccess(response: FacturasFiltro) {
    response.Facturas = this.sortArray(response.Facturas, 'Fecha', false);
    this.sessionService.contratoSelected.Facturas = response.Facturas;
    this.sessionService.contratos[this.sessionService.PosicionContratoSelected].Facturas = response.Facturas;
    this.contratoSelected.Facturas = response.Facturas;

    this.updateDataSource();
  }

  private ObtenerFacturasOnError(response: Response) {

  }

  private updateDataSource() {
    this.data = this.contratoSelected.Facturas;
    if (this.displayedColumns.length > 0) {
      let i = 0;
      this.rows = [];
      const _dataLength = this.data.length;
      while (i < _dataLength) {
        let item = {};
        item[this._colID] = this.data[i]['Identificador'];
        this.displayedColumns.forEach((dc: string) => {
          item[dc] = this.getDataValue(this.data[i][dc]);
        });
        this.rows.push(item);
        i++;
      }
      this.rows = [...this.sortArray(this.rows, 'PeriodoCodigo', false)];
    }
  }

  private getDataValue(dataItem: any) {
    return dataItem === undefined || dataItem === null ? '' : dataItem;
  }

  private cargarVariables(contrato: Contrato): void {
    this.contratoSelected = contrato;
    if (contrato.Facturas.length > 0) {
      this.existenFacturas = true;
      this.typeException = -1;
      this.total = contrato.Facturas[0].TotalFacturado;
      this.consumo = !this.sessionService.isEmmasa ? contrato.Facturas[0].ConsumoReal : contrato.Facturas[0].ConsumoFactura;
      this.periodo = contrato.Facturas[0].Periodo.Descripcion;
      this.periodocorto = contrato.Facturas[0].PeriodoCodigo;
      this.fechalectura = contrato.Facturas[0].FechaLecturaFactura === null ? undefined : contrato.Facturas[0].FechaLecturaFactura;
      this.fechaFactura = contrato.Facturas[0].Fecha === null ? contrato.Facturas[0].FechaRegistro : contrato.Facturas[0].Fecha;
      this.cobrada = contrato.Facturas[0].TotalCobrado >= contrato.Facturas[0].TotalFacturado;
      this.Facturaseleccionada.version = contrato.Facturas[0].Version.toString();
      this.Facturaseleccionada.contratoVersion = contrato.Facturas[0].ContratoVersion.toString();
      this.Facturaseleccionada.facturaCodigo = contrato.Facturas[0].FacturaCodigo.toString();
      this.facturas = contrato.Facturas;
      let facturasPendientes = 0;
      for (const fact of contrato.Facturas.filter(x => x.Fecha !== null)) {
        if (!this.sessionService.isEmmasa) {
          this.dateFac = new Date(fact.Fecha);
          this.dateFac.setDate(this.dateFac.getDate() + 30);
          if (fact.TotalCobrado < ((fact.TotalFacturado - 5)) && (this.dateFac > this.hoy)) {
          }
          facturasPendientes = facturasPendientes++;
        } else {
          this.dateFac = new Date(fact.Fecha);
          this.dateFac.setDate(this.dateFac.getDate() + 5);
          this.hoy = new Date();
          this.hoy.getDate();
          if ((fact.TotalCobrado < fact.TotalFacturado) && (this.hoy > this.dateFac)) {
            facturasPendientes++;
          }
        }
      }
      if (this.sessionService.isEmmasa && this.contratoSelected.Estado === 'C') {
        this.messageCabecera = 'Suministro suspendido por impago';
        this.typeException = !this.contratoSelected.ExistenReclamacionAbiertaBajaOficio ? 7 : 8;
      } else {
        if (facturasPendientes > 0) {
          if (facturasPendientes === 1) {
            this.messageCabecera = 'Factura pendiente de cobro';
          } else {
            this.messageCabecera = 'Varias facturas pendiente de cobro';
          }
          this.typeException = 6;
        } else {
          this.messageCabecera = '';
          this.messageComplet = '';
          this.typeException = 10;
        }
      }
    } else {
      this.existenFacturas = false;
      this.existenFacturasGrafica = false;
      this.messageCabecera = 'Contrato sin facturas';
      this.messageComplet = 'El contrato seleccionado no tiene ninguna factura para mostrar';
      this.typeException = 0;
    }

    this.direccionSuministro = !contrato.Ficticio ? contrato.InmuebleBO.Direccion : null;
    this.Facturaseleccionada.contratoCodigo = contrato.Codigo.toString();
    this.Facturaseleccionada.periodoCodigo = this.periodocorto;
    this.Facturaseleccionada.duplicado = (this.sessionService.efactura);
    this.Facturaseleccionada.firmarFactura = false;
    this.Facturaseleccionada.waterMarkImageFilePath = '';
    if (contrato.Facturas.length > 0) {
      this.Facturaseleccionada.facturaCodigo = contrato.Facturas[0].FacturaCodigo.toString();
    }
    // SYR-198405. No se autoriza al pago por OVE si no permite el sistema o si el contrato está cortado.
    // SYR-301135. Se mueve la comprobación cada vez que se cambie de contrato
    this.permitirPagoOVE = this.sessionService.permitirPagoOVE && this.sessionService.contratoSelected.Estado !== 'C';
  }

  public onDescargarFactura(factura: Factura = null, forceDownload = false) {
    if (factura === null) {
      this.getFacturaDataSession();
    } else {
      this.getFacturaData(factura);
    }
    if (!forceDownload && !this.efactura) {
      this._showModalFactura = true;
    } else {
      this.DescargarFactura();
    }
  }

  private getFacturaDataSession() {
    this.Facturaseleccionada.contratoCodigo = this.sessionService.contratoSelected.Codigo.toString();
    this.Facturaseleccionada.version = this.sessionService.contratoSelected.Facturas[0].Version.toString();
    this.Facturaseleccionada.periodoCodigo = this.sessionService.contratoSelected.Facturas[0].PeriodoCodigo;
    this.Facturaseleccionada.contratoVersion = this.sessionService.contratoSelected.Version.toString();
    this.Facturaseleccionada.facturaCodigo = this.sessionService.contratoSelected.Facturas[0].FacturaCodigo.toString();
  }

  private getFacturaData(factura: Factura) {
    this.Facturaseleccionada.contratoCodigo = factura.ContratoCodigo.toString();
    this.Facturaseleccionada.version = factura.Version.toString();
    this.Facturaseleccionada.periodoCodigo = factura.PeriodoCodigo;
    this.Facturaseleccionada.contratoVersion = this.contratoSelected.Version.toString();
    this.Facturaseleccionada.facturaCodigo = factura.FacturaCodigo.toString();
  }

  public DescargarFactura() {
    this.Facturaseleccionada.duplicado = (this.sessionService.efactura);
    this.Facturaseleccionada.firmarFactura = false;
    this.Facturaseleccionada.waterMarkImageFilePath = '';
    this.userService.descargaFactura(this.Facturaseleccionada)
      .then(
        response => this.DescargaFacturaOnSuccess(response),
        response => this.DescargaFacturaOnError(response)
      );
  }

  private DescargaFacturaOnSuccess(response) {
    let fichero: Blob = response;
    let filename = 'factura_' + this.Facturaseleccionada.periodoCodigo + '.pdf';
    FileSaver.saveAs(fichero, filename);
    this.closeModal();
  }

  private DescargaFacturaOnError(response) {
    this.messageCabecera = 'Error al descargar la factura';
    this.messageComplet = 'Su factura no ha podido ser descargada';
    this.typeException = 0;
  }

  public SeleccionarFacturaTablaPasarela(factura: Factura) {
    if (this.facturaPendiente(factura, true)) {
      this.FacturaPasarela = new Factura();
      //Aplicamos el math.round aunque todos los valores vendran siempre con dos decimales porque en algunos casos
      //genera decimales adicionales. (SYR-364580)
      this.FacturaPasarela.TotalFacturado = Math.round(factura.TotalFacturado * 100);
      this.FacturaPasarela.FacturaCodigo = factura.FacturaCodigo;
      this.FacturaPasarela.ContratoCodigo = factura.ContratoCodigo;
      this.FacturaPasarela.Version = factura.Version;
      this.FacturaPasarela.PeriodoCodigo = factura.PeriodoCodigo;
      this._showModalPasarela = true;
    }
  }

  public subscribirFacturaElectronica() {
    const user: UsuarioUpdate = new UsuarioUpdate();
    let usuarioOnline: UsuarioOnline = new UsuarioOnline();
    usuarioOnline = this.sessionService.usuario;
    usuarioOnline.EFactura = true;
    user.UsuarioOnline = usuarioOnline;

    this.userService.updateuser(this.sessionService.explotacion, user)
      .then(
        response => this.updateuserOnSuccess(response),
        response => this.updateuserOnError(response)
      );
  }

  private updateuserOnSuccess(response) {
    this.efactura = true;
    this.sessionService.efactura = true;
  }

  private updateuserOnError(response) { }

  // METHODS: ORDER TABLE

  lastSortedByField: string = this.displayedColumns[0];
  ascendingOrder = true;

  public showSortIcon(columnName: string) {
    return this.lastSortedByField.toLowerCase() === columnName.toLowerCase();
  }

  public onSortArray(columnName: string) {
    if (this.lastSortedByField === columnName) {
      this.ascendingOrder = !this.ascendingOrder;
    }
    else {
      this.lastSortedByField = columnName;
      this.ascendingOrder = true;
    }
    this.rows = [...this.sortArray(this.rows, columnName, this.ascendingOrder)];
  }

  private sortArray(data: any[], field: string, ascending = true) {
    return data.sort((a, b) => {
      if (a[field] < b[field])
        return ascending ? -1 : 1;
      if (a[field] > b[field])
        return ascending ? 1 : -1;
      return 0;
    });
  }

  // MODAL

  public _showModalFactura = false;
  public _showModalPasarela = false;

  public closeModal() {
    this._showModalFactura = false;
    this._showModalPasarela = false;
  }
}
